import { Col, Divider, message, Row, Space } from "antd";
import React, { Component } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import {
    ButtonItem,
    dineroDisabledMask,
    InputNumberItem,
    ModalItem,
    round2Decimals,
    SelectInsumosItem,
} from "../../../../Components/Items";
import { precioConImpuestos, precioDeLista, precioSinImpuestos } from "./insumosExtra.utils";

//Insumos extra para las ventas que se van a generar (p. ej. la luz del mes). Van sólo en la venta
//generada: la venta programada no cambia. El backend recalcula impuestos y totales; aquí sólo se
//capturan insumo, cantidad y precio, con o sin impuestos.
//
//Estado controlado y no Form.List: cada renglón lleva una `key` propia y estable.

const renglonesVacios = () => ({});

class ModalInsumosExtraVentasProgramadas extends Component {
    state = {
        renglones: renglonesVacios(), // { [ventaProgramadaId]: [{ key, insumoId, insumo, cantidad, precioUnitario, precioConImpuestos }] }
        insumoTodasId: undefined,
        insumoTodas: undefined,
    };

    siguienteKey = 1;

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.setState({ renglones: renglonesVacios(), insumoTodasId: undefined, insumoTodas: undefined });
        }
    }

    nuevoRenglon(ventaProgramada, insumo) {
        const precioUnitario = insumo ? precioDeLista(insumo, ventaProgramada.precioId) : undefined;
        return {
            key: this.siguienteKey++,
            insumoId: insumo?._id,
            insumo,
            cantidad: 1,
            precioUnitario,
            precioConImpuestos: insumo ? precioConImpuestos(precioUnitario, insumo.impuestos, ventaProgramada.tipoDeCambio) : undefined,
        };
    }

    renglonesDe(ventaProgramadaId) {
        return this.state.renglones[ventaProgramadaId] || [];
    }

    agregarRenglon(ventaProgramada, insumo) {
        this.setState((state) => ({
            renglones: {
                ...state.renglones,
                [ventaProgramada._id]: [...(state.renglones[ventaProgramada._id] || []), this.nuevoRenglon(ventaProgramada, insumo)],
            },
        }));
    }

    agregarATodas() {
        const insumo = this.state.insumoTodas;
        if (!insumo) return message.warning("Selecciona el insumo que quieres agregar a todas las ventas");
        this.setState((state) => {
            const renglones = { ...state.renglones };
            this.props.ventasProgramadas.forEach((ventaProgramada) => {
                renglones[ventaProgramada._id] = [...(renglones[ventaProgramada._id] || []), this.nuevoRenglon(ventaProgramada, insumo)];
            });
            return { renglones, insumoTodasId: undefined, insumoTodas: undefined };
        });
    }

    cambiarRenglon(ventaProgramada, key, cambios) {
        this.setState((state) => ({
            renglones: {
                ...state.renglones,
                [ventaProgramada._id]: (state.renglones[ventaProgramada._id] || []).map((renglon) =>
                    renglon.key === key ? { ...renglon, ...cambios(renglon) } : renglon
                ),
            },
        }));
    }

    onChangeInsumo(ventaProgramada, key, insumoId, insumo) {
        this.cambiarRenglon(ventaProgramada, key, () => {
            const precioUnitario = insumo ? precioDeLista(insumo, ventaProgramada.precioId) : undefined;
            return {
                insumoId,
                insumo,
                precioUnitario,
                precioConImpuestos: insumo ? precioConImpuestos(precioUnitario, insumo.impuestos, ventaProgramada.tipoDeCambio) : undefined,
            };
        });
    }

    onChangePrecio(ventaProgramada, key, value) {
        this.cambiarRenglon(ventaProgramada, key, (renglon) => ({
            precioUnitario: value,
            precioConImpuestos: precioConImpuestos(value, renglon.insumo?.impuestos, ventaProgramada.tipoDeCambio),
        }));
    }

    onChangePrecioConImpuestos(ventaProgramada, key, value) {
        this.cambiarRenglon(ventaProgramada, key, (renglon) => ({
            precioConImpuestos: value,
            precioUnitario: precioSinImpuestos(value, renglon.insumo?.impuestos, ventaProgramada.tipoDeCambio),
        }));
    }

    quitarRenglon(ventaProgramada, key) {
        this.setState((state) => ({
            renglones: {
                ...state.renglones,
                [ventaProgramada._id]: (state.renglones[ventaProgramada._id] || []).filter((renglon) => renglon.key !== key),
            },
        }));
    }

    generar() {
        const insumosExtraPorVenta = {};
        for (const ventaProgramada of this.props.ventasProgramadas) {
            const renglones = this.renglonesDe(ventaProgramada._id);
            for (const [indice, renglon] of renglones.entries()) {
                const donde = `Venta ${ventaProgramada.numero}, renglón ${indice + 1}`;
                if (!renglon.insumoId) {
                    message.error(`${donde}: falta el insumo`);
                    return;
                }
                if (!(Number(renglon.cantidad) > 0)) {
                    message.error(`${donde}: la cantidad debe ser mayor a 0`);
                    return;
                }
                if (renglon.precioUnitario === undefined || renglon.precioUnitario === null || renglon.precioUnitario === "" || !(Number(renglon.precioUnitario) >= 0)) {
                    message.error(`${donde}: falta el precio`);
                    return;
                }
            }
            if (renglones.length > 0) {
                insumosExtraPorVenta[ventaProgramada._id] = renglones.map((renglon) => ({
                    insumoId: renglon.insumoId,
                    cantidad: Number(renglon.cantidad),
                    precioUnitario: Number(renglon.precioUnitario),
                    descuento: 0,
                }));
            }
        }
        this.props.onGenerar(insumosExtraPorVenta);
    }

    renderVenta(ventaProgramada) {
        const renglones = this.renglonesDe(ventaProgramada._id);
        let subtotalExtra = 0;
        let totalExtra = 0;
        renglones.forEach((renglon) => {
            subtotalExtra += (Number(renglon.cantidad) || 0) * (Number(renglon.precioUnitario) || 0);
            totalExtra += (Number(renglon.cantidad) || 0) * (Number(renglon.precioConImpuestos) || 0);
        });

        return (
            <div key={ventaProgramada._id} style={{ marginBottom: 10 }}>
                <Divider orientation="left" style={{ marginBottom: 6 }}>
                    <span style={{ fontWeight: "bold" }}>{ventaProgramada.numero}</span>
                    <span style={{ marginLeft: 8 }}>{ventaProgramada.clienteNombre}</span>
                    <span style={{ marginLeft: 8, color: "#666", fontSize: 12 }}>
                        Total actual {dineroDisabledMask(ventaProgramada.total)} {ventaProgramada.moneda}
                    </span>
                </Divider>
                {renglones.length > 0 && (
                    <Row gutter={8} style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                        <Col span={9}>Insumo</Col>
                        <Col span={3}>Cantidad</Col>
                        <Col span={4}>Precio unitario</Col>
                        <Col span={4}>Precio con impuestos</Col>
                        <Col span={3} style={{ textAlign: "right" }}>Importe</Col>
                        <Col span={1} />
                    </Row>
                )}
                {renglones.map((renglon) => (
                    <Row key={renglon.key} gutter={8} align="middle" style={{ marginBottom: 6 }}>
                        <Col span={9}>
                            <SelectInsumosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                clienteId={ventaProgramada.clienteId}
                                cargarAlAbrir
                                insumoPreCargado={renglon.insumo}
                                value={renglon.insumoId}
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo"
                                onChange={(value, insumo) => this.onChangeInsumo(ventaProgramada, renglon.key, value, insumo)}
                            />
                        </Col>
                        <Col span={3}>
                            <InputNumberItem
                                min={0}
                                value={renglon.cantidad}
                                placeholder="Cantidad"
                                onChange={(value) => this.cambiarRenglon(ventaProgramada, renglon.key, () => ({ cantidad: value }))}
                            />
                        </Col>
                        <Col span={4}>
                            <InputNumberItem
                                dinero
                                min={0}
                                value={renglon.precioUnitario}
                                placeholder="Precio unitario"
                                onChange={(value) => this.onChangePrecio(ventaProgramada, renglon.key, value)}
                            />
                        </Col>
                        <Col span={4}>
                            <InputNumberItem
                                dinero
                                min={0}
                                value={renglon.precioConImpuestos}
                                placeholder="Con impuestos"
                                disabled={!renglon.insumo}
                                onChange={(value) => this.onChangePrecioConImpuestos(ventaProgramada, renglon.key, value)}
                            />
                        </Col>
                        <Col span={3} style={{ textAlign: "right", fontSize: 12 }}>
                            {dineroDisabledMask(round2Decimals((Number(renglon.cantidad) || 0) * (Number(renglon.precioUnitario) || 0)))}
                        </Col>
                        <Col span={1}>
                            <MinusCircleOutlined
                                style={{ color: "#ff4d4f", cursor: "pointer" }}
                                onClick={() => this.quitarRenglon(ventaProgramada, renglon.key)}
                            />
                        </Col>
                    </Row>
                ))}
                <Row justify="space-between" align="middle">
                    <Col>
                        <ButtonItem
                            blanco
                            size="small"
                            icon={<PlusOutlined />}
                            onClick={() => this.agregarRenglon(ventaProgramada)}
                        >
                            Agregar insumo
                        </ButtonItem>
                    </Col>
                    {renglones.length > 0 && (
                        <Col style={{ fontSize: 12, textAlign: "right" }}>
                            <div>Nuevo subtotal: {dineroDisabledMask(round2Decimals((ventaProgramada.subtotal || 0) + subtotalExtra))} {ventaProgramada.moneda}</div>
                            <div style={{ fontWeight: "bold" }}>
                                Nuevo total aprox.: {dineroDisabledMask(round2Decimals((ventaProgramada.total || 0) + totalExtra))} {ventaProgramada.moneda}
                            </div>
                        </Col>
                    )}
                </Row>
            </div>
        );
    }

    render() {
        const ventasProgramadas = this.props.ventasProgramadas || [];
        return (
            <ModalItem
                title="Agregar insumos a las ventas"
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                width={window.innerWidth > 1000 ? "85%" : "95%"}
                spinning={false}
                footer={false}
                destroyOnClose
            >
                <p style={{ marginBottom: 6, color: "#666" }}>
                    Los insumos que agregues se suman sólo a la venta que se va a generar; la venta programada no cambia.
                    Una venta sin insumos extra se genera como siempre.
                </p>
                {ventasProgramadas.length > 1 && (
                    <Row gutter={8} align="middle" style={{ marginBottom: 6 }}>
                        <Col span={12}>
                            <SelectInsumosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                cargarAlAbrir
                                value={this.state.insumoTodasId}
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Insumo para todas las ventas (p. ej. Luz)"
                                onChange={(value, insumo) => this.setState({ insumoTodasId: value, insumoTodas: insumo })}
                            />
                        </Col>
                        <Col>
                            <ButtonItem type="primary" icon={<PlusOutlined />} onClick={() => this.agregarATodas()}>
                                Agregar a todas
                            </ButtonItem>
                        </Col>
                    </Row>
                )}
                {ventasProgramadas.map((ventaProgramada) => this.renderVenta(ventaProgramada))}
                <Row justify="end" style={{ marginTop: 10, marginBottom: 10 }}>
                    <Space>
                        <ButtonItem danger onClick={this.props.onCancel}>
                            Cancelar
                        </ButtonItem>
                        <ButtonItem type="primary" onClick={() => this.generar()}>
                            {ventasProgramadas.length > 1 ? `Generar ${ventasProgramadas.length} ventas` : "Generar venta"}
                        </ButtonItem>
                    </Space>
                </Row>
            </ModalItem>
        );
    }
}

export default ModalInsumosExtraVentasProgramadas;
